import { lazy } from "react";

export const PreferencesPopup = lazy(() => import("./PreferencesPopup"));
